import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { FileUploadStatus } from './fileuploadcomponent';


export interface FileUploadCSSStyle extends UIComponentCSSStyle{
    getErrorMsgCSSStyle(): object;
    getInputCSSStyle(): object;
    getFileNameCSSStyle(): object;
    getButtonWrapperCSSStyle() : object;
    getButtonText(): object;
    getButtonStyle(fileStatus: FileUploadStatus): object;
    getUploadIconCSSStyle(): object;
}

export class FileUploadCSSStyleImpl extends UIComponentCSSStyleImpl implements FileUploadCSSStyle 
{
    getWrapperCSSStyle(): object {
        return{
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
            width: "180px"
        };
    }

    getErrorMsgCSSStyle(): object {
        return {
                    marginTop: '2px', 
                    color: this.getResources().getColor(Colors.color_11), 
                    width: '100%', 
                    fontSize: this.getResources().getFont(Fonts.h8), 
                    fontWeight: 600,
                    fontFamily:this.getResources().getFontFamily()
                };
    }

    getFileNameCSSStyle(): object {
        return {
            position: "relative", 
            float: "left",
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            color: this.getResources().getColor(Colors.color_12), 
            width: '100%', 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontWeight: 600,
            fontFamily:this.getResources().getFontFamily()
        };
    }

    getInputCSSStyle(): object 
    {
        return{
            position: 'relative',
            display: 'none',
        };
    }
      
    getButtonWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '50px', 
        width: '100%', 
        cursor: "default",
      };
    }

    getButtonStyle(fileStatus: FileUploadStatus): object 
    {
       return {
      //  width:'159px',
        height: '50px',
        float: 'left', 
        borderRadius: '4px',
        minWidth: '120px',
        overflow: 'hidden',
        backgroundColor: this.getColor(fileStatus),
        cursor: "pointer",
        border: 'none',
        width: "100%",
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
           
      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_5), 
            fontSize: this.getResources().getFont(Fonts.h8), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "50px",
            textAlign: "center",
            height: "50px",
            fontWeight: "bold",
            letterSpacing: 0, 
            width: "120px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 

     getUploadIconCSSStyle(): object {
        return {
            marginLeft: "5px",
            float: "left",
            height: "31.5px",
            width: "31.5px",
            marginTop: "7px",
       };
    }

    private getColor(fileStatus: FileUploadStatus)
    {
        if(fileStatus === FileUploadStatus.FILE_UPLOADING)
        {
            return this.getResources().getColor(Colors.color_19);    
        }
        else if(fileStatus === FileUploadStatus.FILE_UPLOADED)
        {
            return "#76B943";     
        }
        else if(fileStatus === FileUploadStatus.FILE_UPLOAD_FAILED)
        {
           return this.getResources().getColor(Colors.color_12);    
        }
        else
        {
            return this.getResources().getColor(Colors.color_2);
        }
    }
 }


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/fileupload/fileuploadcss.tsx